module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH4QQDDB0yyFivUQAAAC1JREFUOMtj/P//PwMlgImBQkCxAYwMDAz/h7YXWFatGuqxMBqNDAyMQz8zAQBMkApqbg0fWgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_bp_glp.png
// module id = iqQy
// module chunks = 0